<template>
  <div>
    <ValidationProvider :name="$t(itemName)" rules="required" v-slot="{ errors }">
      <v-autocomplete
        v-model="editedBom"
        :items="bomList"
        item-text="Name"
        item-value="Id"
        return-object
        :loading-text="$t('common_get_data')"
        :no-data-text="$t('common_no_results')"
        :error-messages="errors[0]"
        @click="getAllBoms"
        @change="setBomItem"
        ref="bomNameAutocomplete"
        @keyup.enter="keyupEnter"
      >
        <template v-slot:label>
          <span class="red--text">
            <strong>* </strong>
          </span>
          {{ $t('quotation_item_name') }}
        </template>
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.Name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ data.item.Describe }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
    </ValidationProvider>
  </div>
</template>

<script>
import { HttpBom } from '@/js/http-Manager'
export default {
  name: 'QuotationBomAutocomplete',
  props: {
    fatherEditedItem: {
      type: Object
    },
    editedItemIndex: {
      type: Number
    },
    itemName: {
      type: String
    },
    repairCustomerId: {
      type: String
    },
    refName: {
      type: String
    },
    customerDeviceType: {
      type: Number
    }
  },
  components: {},
  data: () => ({
    bomList: [],
    bomSource: null,
    isLoading: false,
    editedBom: {
      Number: '',
      Name: '',
      Price: 0,
      Unit: '',
      Quantity: 0,
      Describe: '',
      BomItems: [],
      Remark: ''
    },
    defaultBom: {
      Number: '',
      Name: '',
      Price: 0,
      Unit: '',
      Quantity: 0,
      Describe: '',
      BomItems: [],
      Remark: ''
    }
  }),
  async mounted () {
    await this.getAllBoms()
  },
  watch: {
    async fatherEditedItem (val) {
      if (val.Id === '') {
        await this.getAllBoms()
        this.editedBom = JSON.parse(JSON.stringify(this.defaultBom))
      } else {
        this.editedBom = JSON.parse(JSON.stringify(val))
      }
    },
    async customerDeviceType (oldVal, newVal) {
      if (
        ((oldVal === 0 || oldVal === 3) && (newVal === 1 || newVal === 2)) ||
        ((oldVal === 1 || oldVal === 2) && (newVal === 0 || newVal === 3))
      ) {
        await this.getAllBoms()
        this.$emit('setBomItem', this.defaultBom)
      }
    }
  },
  methods: {
    async getAllBoms () {
      this.isLoading = true
      let param = {
        customerDeviceType: this.customerDeviceType ? this.customerDeviceType : null
      }
      let response = await HttpBom.GetBomListFromCustomerDevice(param)
      if (response) {
        this.bomList = response.status === 200 ? response.data.Data : []
      }
      this.isLoading = false
    },
    setBomItem () {
      this.$emit('setBomItem', this.editedBom)
    },
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    }
  }
}
</script>
